import HorarioDeTrabalho, { FinderHorariosDeTrabalho, RetornoHorarioDeTrabalho } from 'Interface/HorariosDeTrabalho';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'HorariosDeTrabalho';

const url = '/horarios-de-trabalho';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag, 'VinculosEmpregaticios'],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarHorariosDeTrabalho: construtor.query<FinderHorariosDeTrabalho, Parametros | void>({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.horarios
            ? [
                ...resultado.horarios.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarHorarioDeTrabalho: construtor.query<
        RetornoHorarioDeTrabalho,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarHorarioDeTrabalho: construtor.mutation<HorarioDeTrabalho, Partial<HorarioDeTrabalho>>({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: formData(dados, 'POST'),
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarHorarioDeTrabalho: construtor.mutation<
        HorarioDeTrabalho,
        Partial<HorarioDeTrabalho> & Pick<HorarioDeTrabalho, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'PUT'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerHorarioDeTrabalho: construtor.mutation<
        HorarioDeTrabalho,
        Partial<HorarioDeTrabalho> & Pick<HorarioDeTrabalho, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'DELETE'),
        }),
        invalidatesTags: (resultado, erro, { id, ...dados }) =>
          !erro ? [{ type: tag, id }, { type: 'VinculosEmpregaticios', id: dados.vinculo_id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarHorariosDeTrabalhoQuery,
  useRecuperarHorarioDeTrabalhoQuery,
  useAdicionarHorarioDeTrabalhoMutation,
  useEditarHorarioDeTrabalhoMutation,
  useRemoverHorarioDeTrabalhoMutation,
} = apiExtendida;
